/**
 * The routes search engines must not index, in one place: src/proxy.ts gates or
 * hides them, _app.tsx marks them noindex, and the sitemap leaves them out
 * because it lists only pages that ask to be indexed.
 */

/** Behind a login. Their access pages stay reachable but are not for search. src/proxy.ts repeats these in its matcher. */
export const PRIVATE_PREFIXES = ["/inner-circle", "/pme"];

/** Works in progress and retired pages: they 404 in production. src/proxy.ts repeats these in its matcher. */
export const UNLISTED_PREFIXES = ["/_draft", "/_deprecated", "/blog/category/drafts"];

/** Pages that exist for tools or errors rather than readers. */
export const UTILITY_ROUTES = [
  "/404",
  "/500",
  "/_error",
  "/neon-city-render",
  "/deep-dive-render",
  "/long-exposure-render",
  "/long-exposure-bench",
  "/lightning-machine-render",
  "/lightning-machine-bench"
];

export function matchesPrefix(path: string, prefixes: string[]): boolean {
  const pathname = path.split(/[?#]/)[0];
  return prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

/** Whether a page must carry noindex. Takes every path a page is known by: a rewrite's public URL and its file. */
export function isUnindexed(...paths: string[]): boolean {
  return paths.some(
    (path) =>
      matchesPrefix(path, PRIVATE_PREFIXES) ||
      matchesPrefix(path, UNLISTED_PREFIXES) ||
      UTILITY_ROUTES.includes(path.split(/[?#]/)[0])
  );
}
